
import { Product } from "@/types/product";

export const vpxUC1ULTRA: Product = {
  id: "vpx-uc1-ultra",
  groupId: "avoip",
  name: "VPX-UC1-ULTRA",
  subtitle: "1Gb Box Transceiver",
  description: "The VPX-UC1-ULTRA is a powerful universal controller designed specifically for managing and controlling Aurora's 1G AV over IP ecosystem. This advanced control processor provides comprehensive system management capabilities, including device discovery, configuration, and real-time monitoring of all VPX devices on the network.\n\nFeaturing dual network ports for enhanced reliability and security, the VPX-UC1-ULTRA offers sophisticated management tools through its intuitive web interface and robust API. The controller supports multiple user access levels, scheduled tasks, and custom macro programming for automated system operations.\n\nWith its ability to manage up to 250 devices and support for both standard and complex configurations, the VPX-UC1-ULTRA is the ideal control solution for large-scale VPX deployments in enterprise, education, and government installations.",
  features: [
    "Configure as Encoder or Decoder",
    "Zero Frame Latency (1.78ms)",
    "4K60 4:4:4 UHD 120m over 1G CAT 5e",
    "HDMI 2.0b, HDCP 2.2",
    "HDR10, HDR10+, Dolby Vision",
    "LPCM up to 12-channels, Dolby Digital Plus, Dolby TrueHD DTS HD Master Audio & ATMOS",
    "12 bits color depth processing, 16bits OSD",
    "Enterprise Security (AES 256, 802.1x, HTTPS, & SSH)",
    "Scaling, Seamless Switching & Video Wall with Rotation",
    "MJPEG Preview up to 720p30",
    "2.5G LAN PoE+ and 1G SFP for Fiber or 2nd RJ-45",
    "2 HDMI Outputs, 1 HDMI Input",
    "Line In/Out Stereo",
    "RS-232 Serial Port and IR (In/Out)",
    "Channel Mapping with On-Screen Preview",
    "Integrated Web Server for Configuration",
    "USB 2.0 Ports for Cameras, HID Devices, Mass Storage, etc.",
    "AES67 Included",
    "Dante® 2 Ch Audio License Option",
    "Rack and Under Table Mounting",
    "Processor",
    "8 Core 2.4GHz Processor • Android 12 OS",
    "1TB SSD Option",
    "3 USB 3.1",
    "Singal 8K HDMI Outputs or Dual 4K HDMI Outputs",
    "Options",
    "TeamStream 4K Wireless WiFi Video",
    "ReAX Control Server"
  ],
  specifications: [
    "Model Name: VPX-UC1-ULTRA",
    "CPU: Android 12, 8-Core 64-bit ARM Processor 2.4GHz with 6TOP NPU",
    "Memory: 32GB FLASH with 4GB RAM & (Up to 1TB SSD Expansion)",
    "USB Ports: 2 USB 3.1 Type A, 1 Type-C",
    "HDMI Outputs: 2 (HDMI 2.1, HDCP 2.3) Up to 8K60 (Note: Only 1 can be 8K60 while other will be 4K)",
    "Compression: Mimix™ 13:1",
    "Latency: 0 Frame (1.78ms) with Ultra Low Latency Mode",
    "HDMI Inputs: 1 (HDMI 2.0b, HDCP 2.2)",
    "Encryption: AES 256",
    "Audio Analog: Stereo Line In/Out (3.5mm TRS)",
    "1G Ethernet: RJ-45 and SFP",
    "LAN: RJ-45 10/100/1000M PoE",
    "Video Bandwidth: 600MHz (Up to 4K2K 4:4:4 @ 60Hz)",
    "Audio Support: Up to 12 Channels",
    "Video Stream Bandwidth: 10Mbps – 800Mbps (4K60 4:4:4)",
    "USB Bandwidth: 200Mbps (Camera), 160Mbps (HID/Mass Storage Devices)",
    "RS-232: Up to 115k Baud (3.5mm TRS)",
    "IR: Bi-Directional (3.5mm TRS)",
    "USB Connector: 1 USB 2.0 Type C, 2 USB 2.0 Type A",
    "Options: Dante® 2Ch License",
    "Interface: IR or Keyboard via OSD, Web Server",
    "Housing: Black Aluminum Enclosure",
    "Dimensions (L x W x H): 7\" x 7.44\" x 1.094\" (17.7cm x 18.9cm x 2.75cm)",
    "Weight: .453kg [1lbs]",
    "Mounting: Optional: Rack Mount Vertical, Rack Mount Horizontal, Under Table Mount",
    "Power Supply: 48v DC (2 Pin Euro) or PoE+ (LAN)",
    "Power Consumption: 12 Watts, up to 20 Watts with USB",
    "Operation Temperature: 0~40o C [32~104o F]",
    "Storage Temperature: -20~60o C [-4~140o F]",
    "Relative Humidity: 20~90% RH [No Condensation]",
    "Package Contents: 1x VPX-UC1-ULTRA, 2x Mounting Ears"
  ],
  images: [
    "/lovable-uploads/6278ed78-3cd6-4953-9ede-441271cb79a6.png"
  ],
  videoUrl: "https://www.youtube.com/watch?v=hXnEXDMCD3s",
  slug: "vpx-uc1-ultra",
  networkSpeed: "1gb"
};
